import { VendorResponse } from "./vendor.model"
import { WarehouseResponse } from "./warehouse.model"

export class SaleResponse {
	id: number;
	company: number;
	client: number;
	warehouse: number;
	cash: any;
	nit: string;
	name: string;
	date: any;
	accountingDate: number;
	series: string;
	number: string;
	lot: any;
	totalCost: number;
	taxPercentage: number;
	totalTaxes: number;
	discount: number;
	currency: number;
	exchangeRate: number;
	invoice: boolean;
	user: number;
	balance: number;
	balanceBk: number;
	inventoryItem: any;
	clientItem: number;
	creationDate: number;
	description: string;
	transactionType: string;
	cancelled: boolean;
	cancelledDescription: any;
	gfaceGenerated: boolean;
	downloadable: boolean;
	providerInvoice: any;
	provisionalIncome: any;
	hasISR: boolean;
	hasIVA: boolean;
	hasExemption: any;
	clientData: VendorResponse;
	warehouseData: WarehouseResponse;
	hasExtraTax: boolean;
	totalExtraTax: number;
	exchange: number;
	totalSubsidio: number;
	ncElectronic: boolean;
	hasAffiliate: boolean;
	nitAffiliate: any;
	isExport: boolean;
	consigneeName: string;
	consigneeAdress: string;
	consigneeCode: string;
	buyerName: string;
	buyerAdress: string;
	buyerCode: string;
	otherReference: string;
	incoterm: any;
	exporterName: string;
	exporterAdress: string;
	//only for frontend
	detail!: any;
	methodPay: any;
	isNcre?: boolean;
	documentTypeName?: string;

	constructor(){

	}
}

export class PriceClientResponse {
	id: number;
	company: number;
	warehouse: number;
	client: number;
	nit: string;
	name: string;
	totalCost: number;
	discount: number;
	currency: number;
	exchangeRate: number;
	invoice: boolean;
	user: number;
	creationDate: Date;
	deadline: Date;
	description: string;
	cancelled: boolean;
	executed: boolean;
	downloadable: boolean;
	hasAffiliate: boolean;
	valorAffiliate: string;
	pointsAffiliate: number;
	constructor(){

	}
}